import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "zxhj-record-list"
};
var _hoisted_2 = {
  class: "filter"
};
var _hoisted_3 = {
  class: "back_btn"
};
var _hoisted_4 = {
  class: "search"
};
var _hoisted_5 = {
  id: "list",
  class: "list"
};
var _hoisted_6 = {
  class: "left"
};
var _hoisted_7 = {
  class: "info"
};
var _hoisted_8 = {
  class: "tag"
};
var _hoisted_9 = {
  class: "name"
};
var _hoisted_10 = {
  class: "result"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  class: "name"
};
var _hoisted_13 = {
  key: 1,
  class: "loaded"
};
var _hoisted_14 = {
  key: 2,
  class: "empty"
};
import dayjs from 'dayjs';
import Empty from '../Empty.vue';
import checkEdit from '../CheckEdit';
import avatar from '@/components/Avatar';
import { computed, onMounted, ref, watch, onBeforeUnmount } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { deleteExecute, getAcceptView } from '@/api/index-ping';
import { putEvaluateSubmit } from '@/api/index-ping';
export default {
  __name: 'index',
  props: {
    // 列表查询参数
    queryParams: {
      type: Object,
      default: function _default() {
        return {
          evaluateObjectName: '',
          // 用户名 可选参数
          recordResult: '',
          // 验收结果 可选参数 查询全部时可传空
          recordTimeStr: '',
          // 记录时间 本周：period；今日：today 可选参数
          periodId: '',
          // 周期id 可选参数
          secondNodeId: '',
          // 指标分类 可选参数 查询全部时可传空
          groupId: '',
          // 小组id 可选参数
          type: '',
          // 类型 必选参数  个人报告：personal;班级报告：class;小组报告:group;
          current: '1',
          // 当前页码 必选参数
          size: '10' // 每页查询数 必选参数
        };
      }
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['totalCount', 'toShowAll'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;

    // 查询到的列表数量
    var emits = __emit;
    var observerTarget = ref(null); //  滚动容器
    var submitLoading = ref(false);
    var deleteLoading = ref(false);
    var recordList = ref([]);
    var total = ref(0);
    var keyword = ref('');
    var params = computed(function () {
      return _objectSpread(_objectSpread(_objectSpread({}, props.queryParams), {
        size: 10,
        current: 1
      }), {
        evaluateObjectName: keyword.value
      });
    });
    var noMore = ref(false);

    /**
     * 筛选条件查询
     */
    var getFilterData = function getFilterData() {
      observer.disconnect();
      params.value.current = 1;
      recordList.value = [];
      loadMoreData().finally(function () {
        if (observerTarget.value) observer.observe(observerTarget.value);
      });
    };
    // 加载数据
    var loadMoreData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$getAcceptView, data, newRecords, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return getAcceptView(params.value);
            case 1:
              _yield$getAcceptView = _context.v;
              data = _yield$getAcceptView.data;
              params.value.current++;
              newRecords = data.data.records || [];
              total.value = data.data.total || 0;
              emits('totalCount', total.value); // 返回数量
              recordList.value = [].concat(_toConsumableArray(recordList.value), _toConsumableArray(newRecords));
              noMore.value = recordList.value.length >= total.value;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              MessagePlugin.error((_t === null || _t === void 0 ? void 0 : _t.message) || '列表加载失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function loadMoreData() {
        return _ref2.apply(this, arguments);
      };
    }();
    // 创建 Intersection Observer 实例
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 目标元素进入视口，触发加载更多数据
          !noMore.value && loadMoreData();
        }
      });
    }, {
      root: document.getElementById('list'),
      // 默认为视口
      threshold: 0.2 // 当目标元素的20%可见时触发回调
    });

    // 抽屉显示变量
    var editShow = ref(false); // 详情抽屉
    var checkData = ref(null); // 选择的数据

    /**
     * 点击评价条目查询详情
     * @param item
     */
    var handleEditItem = function handleEditItem(item) {
      checkData.value = item;
      editShow.value = true;
    };

    /**
     * 保存提交
     */
    var submitForm = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              submitLoading.value = true;
              _context2.n = 1;
              return putEvaluateSubmit(data);
            case 1:
              MessagePlugin.success('修改成功！');
              editShow.value = false; // 关闭详情抽屉
              _context2.n = 2;
              return getFilterData();
            case 2:
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              MessagePlugin.error('修改失败！');
            case 4:
              _context2.p = 4;
              submitLoading.value = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 3, 4, 5]]);
      }));
      return function submitForm(_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    /**
     * 删除评价
     */
    var deleteExecuteItem = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
        var _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              deleteLoading.value = true;
              _context3.n = 1;
              return deleteExecute(id);
            case 1:
              MessagePlugin.success('删除成功！');
              checkData.value = null; // 详情数据清空
              editShow.value = false; // 关闭详情抽屉
              getFilterData();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              MessagePlugin.error((_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || '删除失败！');
            case 3:
              _context3.p = 3;
              deleteLoading.value = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2, 3, 4]]);
      }));
      return function deleteExecuteItem(_x2) {
        return _ref4.apply(this, arguments);
      };
    }();

    /**
     * 点击返回
     *
     */
    var detailJump = function detailJump() {
      emits('toShowAll');
    };
    // 监听参数变化
    var timer = null;
    watch(function () {
      return params.value;
    }, function (val) {
      try {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          getFilterData();
        }, 300);
      } catch (error) {
        MessagePlugin.error((error === null || error === void 0 ? void 0 : error.message) || '获取记录失败');
      }
    }, {
      deep: true
    });
    onMounted(function () {
      observer.observe(observerTarget.value);
    });
    onBeforeUnmount(function () {
      observer.disconnect();
      timer = null;
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_input = _resolveComponent("t-input");
      var _component_BallFlickerLoading = _resolveComponent("BallFlickerLoading");
      var _component_t_drawer = _resolveComponent("t-drawer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_svg_icon, {
        name: "arrow-left",
        onClick: detailJump
      }), _cache[2] || (_cache[2] = _createTextVNode(" 验收详情 ", -1))]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_t_input, {
        modelValue: keyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return keyword.value = $event;
        }),
        class: "search-input",
        placeholder: "请输入验收人姓名"
      }, {
        prefixIcon: _withCtx(function () {
          return [_createVNode(_component_svg_icon, {
            name: "person-search",
            size: "20",
            class: "search-icon"
          })];
        }),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recordList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "record-item"
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.secondNodeName), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(item.targetName), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, [_cache[3] || (_cache[3] = _createTextVNode(" 验收结果： ", -1)), _createElementVNode("span", null, _toDisplayString(item.recordResult), 1)]), _createElementVNode("p", null, [_cache[4] || (_cache[4] = _createTextVNode(" 验收人： ", -1)), _createElementVNode("span", null, _toDisplayString(item.evaluatorName), 1)]), _createElementVNode("p", null, [_cache[5] || (_cache[5] = _createTextVNode(" 验收时间： ", -1)), _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(item.createTime).format('MM.DD HH:mm')), 1)])])]), _createElementVNode("div", {
          class: "right",
          onClick: function onClick($event) {
            return handleEditItem(item);
          }
        }, [_createVNode(_unref(avatar), {
          class: "avatar",
          "avatar-url": item.evaluateObjectAvatar
        }, null, 8, ["avatar-url"]), _createElementVNode("span", _hoisted_12, _toDisplayString(item.evaluateObjectName), 1), _createVNode(_component_svg_icon, {
          name: "arrow-right",
          size: "20"
        })], 8, _hoisted_11)]);
      }), 128)), !noMore.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "observerTarget",
        ref: observerTarget,
        class: "loading"
      }, [_createVNode(_component_BallFlickerLoading)], 512)) : _createCommentVNode("", true), noMore.value && recordList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, "没有更多了~")) : noMore.value && total.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(Empty, {
        name: "notice"
      })])) : _createCommentVNode("", true)])]), _createVNode(_component_t_drawer, {
        visible: editShow.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return editShow.value = $event;
        }),
        size: "45%",
        footer: false
      }, {
        default: _withCtx(function () {
          return [editShow.value ? (_openBlock(), _createBlock(_unref(checkEdit), {
            key: 0,
            data: checkData.value,
            columns: __props.columns,
            params: params.value,
            "delete-loading": deleteLoading.value,
            "submit-loading": submitLoading.value,
            onDelete: deleteExecuteItem,
            onSubmit: submitForm
          }, null, 8, ["data", "columns", "params", "delete-loading", "submit-loading"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible"])], 64);
    };
  }
};